export const getRailsEnv = (): string => {
  return (
    document.querySelector('meta[name="rails-env"]')?.getAttribute('content') ||
    'development'
  );
};

export const isDevelopmentEnv = (): boolean => getRailsEnv() === 'development';

export const isTestEnv = (): boolean => getRailsEnv() === 'test';

export const isProductionEnv = (): boolean => getRailsEnv() === 'production';

export const MOCK_COGNITO_ACCESS_TOKEN = 'mock-cognito-access-token';
